import { render, staticRenderFns } from "./chat-btn-down.vue?vue&type=template&id=4e7ce884"
import script from "./chat-btn-down.vue?vue&type=script&lang=js"
export * from "./chat-btn-down.vue?vue&type=script&lang=js"
import style0 from "./chat-btn-down.vue?vue&type=style&index=0&id=4e7ce884&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports